
import React, { useEffect } from 'react'
import useLocalStorage from './useLocalStorage'
import fs from 'fs'

/**
 * Default theme.
 */

const defaultTheme = prefersDark()
  ? 'dark'
  : 'light'

/**
 * Theme imports.
 */

const themes = {
  light: {
    name: 'Light',
    color: '#ffffff'
  },
  dark: {
    name: 'Dark',
    color: '#0B0B0F'
  },
  gray: {
    name: 'Gray',
    color: '#252525'
  }
}

/**
 * useTheme hook.
 */

export default function useTheme() {
  const [name, setTheme] = useLocalStorage('theme', defaultTheme)
  
  async function load() {
    const theme = themes[name]
    if (!theme) return console.warn('invalid theme')
    document.body.dataset.theme = name
    document.head.querySelector('[name=theme-color]').setAttribute('content', theme.color)
  }

  function change(e) {
    setTheme(e.matches ? 'dark' : 'light')
  }

  useEffect( _ => {
     load()
     window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', change)
     return _ => {
       window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', change)
     }
  }, [name])

  return [name, setTheme]
}

/**
 * prefers dark color scheme.
 */

function prefersDark() {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
}